<template>
  <div class="app-links">
    <div class="text-h6 font-weight-semibold mb-5">
      Eventeros
    </div>
    <div class="d-flex flex-column">
      <router-link :to="{name: 'blog'}">
        Blog
      </router-link>
      <router-link :to="{name: 'aboutus'}">
        Sobre nosotros
      </router-link>
      <router-link :to="{name: 'termsandconditions'}">
        Términos y condiciones
      </router-link>
      <router-link :to="{name: 'privacypolicy'}">
        Política de privacidad
      </router-link>
      <router-link :to="{name: 'faq'}">
        Preguntas frecuentes
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLinks',
};
</script>

<style lang="scss" scoped>
.app-links {
  a {
    line-height: 27px;
    color:#fff!important;
  }
}
</style>
